/**
 * It takes a url, a file, and a file type and uploads the file to the S3 url.
 * </code>
 * @param urlAWS - The url to the AWS S3 bucket
 * @param file - The file you want to upload
 * @param fileType - The type of file you're uploading.
 * @returns a promise.
 */
import axios from 'axios';
export const uploadImage = async (urlAWS, file, fileType) => {
  var config = {
    method: 'put',
    url: urlAWS,
    headers: {
      'Content-Type': fileType,
    },
    data: file,
  };

  try {
    const uploaded = await axios(config)
      .then(function (response) {
        //Uploaded
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
    return uploaded;
  } catch (error) {
    console.log(error);
    return error;
  }
};
